module.exports = __webpack_public_path__ + "img/definir_agenda.085ed7e2.svg";